import React from 'react';
import { Button, rem } from '@mantine/core';
import { IconMessageChatbot } from '@tabler/icons-react';

import * as classes from './ButtonContatto.module.css';


function ButtonContatto({ formContattiLabelCta, apriFormContattoFunction }) {
  return (
    <Button
      className={classes.button}
      variant="light"
      rightSection={(
        <IconMessageChatbot
          style={{ width: rem(24), height: rem(24) }}
          stroke={1.5}
        />
      )}
      radius="xl"
      size="md"
      styles={{
        root: { paddingRight: rem(14), height: rem(48) },
        section: { marginLeft: rem(22) },
      }}
      onClick={apriFormContattoFunction}
    >
      {formContattiLabelCta}
    </Button>
  );
}

export default ButtonContatto;
